const ALL_COMPANY_IDS = [
  "shivshankar",
  "mark-merc",
  "world-trans",
  "geo-logistics",
];

const DEFAULT_TENANT_USERS = [
  {
    id: "usr-admin",
    name: "Priya Sharma",
    email: "priya@developer-gps.example",
    role: "group_admin",
    systemCustomerId: "sc-dev-gps",
    companyIds: ALL_COMPANY_IDS,
    active: true,
  },
  {
    id: "usr-ca-shiv",
    name: "Shivshankar Admin",
    email: "admin.shivshankar@developer-gps.example",
    role: "company_admin",
    systemCustomerId: "sc-dev-gps",
    companyIds: ["shivshankar"],
    active: true,
  },
  {
    id: "usr-ca-mm",
    name: "Mark/Merc Admin",
    email: "admin.markmerc@developer-gps.example",
    role: "company_admin",
    systemCustomerId: "sc-dev-gps",
    companyIds: ["mark-merc"],
    active: true,
  },
  {
    id: "usr-ca-wt",
    name: "World Trans Admin",
    email: "admin.worldtrans@developer-gps.example",
    role: "company_admin",
    systemCustomerId: "sc-dev-gps",
    companyIds: ["world-trans"],
    active: true,
  },
  {
    id: "usr-ca-geo",
    name: "Geo Logistics Admin",
    email: "admin.geologistics@developer-gps.example",
    role: "company_admin",
    systemCustomerId: "sc-dev-gps",
    companyIds: ["geo-logistics"],
    active: true,
  },
  {
    id: "usr-sales",
    name: "Rahul Kulkarni",
    email: "rahul@developer-gps.example",
    role: "order_executive",
    systemCustomerId: "sc-dev-gps",
    companyIds: ["world-trans", "geo-logistics"],
    active: true,
  },
  {
    id: "usr-planner",
    name: "Neha Desai",
    email: "neha@developer-gps.example",
    role: "planner",
    systemCustomerId: "sc-dev-gps",
    companyIds: ["shivshankar"],
    active: true,
  },
  {
    id: "usr-ops",
    name: "Karan Joshi",
    email: "karan@developer-gps.example",
    role: "operations",
    systemCustomerId: "sc-dev-gps",
    companyIds: ["shivshankar", "mark-merc"],
    active: true,
  },
  {
    id: "usr-acct",
    name: "Meera Shah",
    email: "meera@developer-gps.example",
    role: "accountant",
    systemCustomerId: "sc-dev-gps",
    companyIds: ALL_COMPANY_IDS,
    active: true,
  },
  {
    id: "usr-driver",
    name: "Sanjay Patil",
    email: "driver@developer-gps.example",
    role: "driver",
    systemCustomerId: "sc-dev-gps",
    companyIds: ["shivshankar"],
    active: true,
  },
  {
    id: "usr-buyer",
    name: "Buyer portal user",
    email: "buyer@developer-gps.example",
    role: "buyer",
    systemCustomerId: "sc-dev-gps",
    companyIds: ["shivshankar"],
    active: true,
  },
  {
    id: "usr-seller",
    name: "Seller portal user",
    email: "seller@developer-gps.example",
    role: "seller",
    systemCustomerId: "sc-dev-gps",
    companyIds: ["world-trans"],
    active: true,
  },
  {
    id: "usr-port",
    name: "Mundra port desk",
    email: "port@developer-gps.example",
    role: "port_member",
    systemCustomerId: "sc-dev-gps",
    companyIds: ["shivshankar", "mark-merc"],
    active: true,
  },
  {
    id: "usr-workshop",
    name: "Ramesh Mistry",
    email: "workshop@developer-gps.example",
    role: "workshop_manager",
    systemCustomerId: "sc-dev-gps",
    companyIds: ["shivshankar"],
    active: true,
  },
  {
    id: "usr-harbor-admin",
    name: "Vikram Nair",
    email: "admin@harbor-line.example",
    role: "group_admin",
    systemCustomerId: "sc-harbor-line",
    companyIds: ["shivshankar"],
    active: true,
  },
];

export { ALL_COMPANY_IDS, DEFAULT_TENANT_USERS };
